import {
    MymachineResponse,
    ShopType,
    SoftwareUpdatesState
} from "../../src/components/data-controller-mymachine/mymachine-response";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const filter = `
<ux-filter id="mymachine-filter">
    <div class="row">
        <div class="gr-10 push-1 gr-12@m push-0@m">
            <label class="ux-label">Filter</label>
            <div class="row">
                <div class="mymachine-overview__filter-dropdown">
                    <ux-dropdown placeholder="Filter 1">
                        ${[1, 2, 3, 4]
                            .map(
                                (i) => `
                            <ux-checkbox-list-item name="e${i}" value="val_${i}" label="Entry ${i}"></ux-checkbox-list-item>
                        `
                            )
                            .join("")}
                    </ux-dropdown>
                </div>
                <div class="mymachine-overview__filter-dropdown">
                    <ux-dropdown placeholder="Filter 2">
                        ${[5, 6, 7, 8]
                            .map((i) => {
                                const attribute =
                                    i === 5
                                        ? "disabled"
                                        : i === 6
                                        ? "checked"
                                        : "";
                                return `<ux-checkbox-list-item name="e${i}" value="val_${i}" label="Entry ${i}" ${attribute}></ux-checkbox-list-item>`;
                            })
                            .join("")}
                    </ux-dropdown>
                </div>
                <div class="mymachine-overview__filter-checkboxes">
                    <ux-checkbox class="mymachine-overview__filter-checkbox" name="fav" value="fav_only" label="only Favorites" checked></ux-checkbox>
                    <ux-checkbox class="mymachine-overview__filter-checkbox" name="ordered" value="ordered_only" label="only ordered" checked></ux-checkbox>
                    <ux-checkbox class="mymachine-overview__filter-checkbox" name="discontinued" value="discontinued_only" label="Reduced Service Support only" checked></ux-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="gr-10 push-1 gr-12@m push-0@m">
            <label class="ux-label">Active Filters:</label>
            <div class="ux-tag-list"></div>
        </div>
    </div>
</ux-filter>
`;

const getPageLink = (page: number, modifierName: string = "") =>
    `generated-mock-data/mymachine${modifierName}-page${page}.json`;

const response: MymachineResponse = {
    nextPage: getPageLink(2),
    totalCount: 123,
    filteredCount: 5,
    filterHTML: filter,
    isCreateCaseAllowed: true,
    disabledCreateCaseHeaderText: "Create Case Disabled",
    disabledCreateCaseBodyText:
        "This feature has been disabled since you do not have the required access rights. Please contact your company admin if you require access.",
    items: [
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM01",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
                {
                    link: "#",
                    shopType: ShopType.BENDING,
                    linkText: "Bending tools Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "classic",
            softwareUpdates: {
                state: SoftwareUpdatesState.SUBSCRIBED,
                label: "Updates subscribed"
            },
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM02",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
                {
                    link: "#",
                    shopType: ShopType.BENDING,
                    linkText: "Bending tools Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            discontinued: {
                status: "soc",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
                text:
                    "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                linkText: "Mehr erfahren",
                extendedSupport: true,
            },
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "classic",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM03",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
                {
                    link: "#",
                    shopType: ShopType.BENDING,
                    linkText: "Bending tools Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            discontinued: {
                status: "soc",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
                text:
                    "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                linkText: "Mehr erfahren",
                extendedSupport: false,
            },
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "classic",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM104",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
                {
                    link: "#",
                    shopType: ShopType.PUNCHING,
                    linkText: "Punching tools Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            discontinued: {
                status: "sod",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wurde zum 31.12.2021 abgekündigt.",
                text:
                    "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                linkText: "Mehr erfahren",
                extendedSupport: false,
            },
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: false,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM005",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            discontinued: {
                status: "sod",
                type: "machine",
                date: "XX.XX.XXXX",
                head: "Das Produkt wurde zum 31.12.2021 abgekündigt.",
                text:
                    "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                linkText: "Mehr erfahren",
                extendedSupport: true,
            },
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM1016",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: false,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "basic",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM0007",
            detailLink: "#",
            shopLinks: null,
            serviceCallModalLink: "",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
            softwareUpdates: {
                state: SoftwareUpdatesState.UPDATE_AVAILABLE,
                label: "Update available"
            },
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM1028",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: false,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM00009",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: true,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM10300",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    shopType: ShopType.SPAREPARTS,
                    linkText: "Spare parts Shop",
                    linkTarget: "_blank",
                },
            ],
            serviceCallModalLink: "",
            image: "./mock-assets/images/trulaser-station-7000.jpg",
            isFav: false,
            toggleFavUrl: "mock-data/mymachine.json",
            constructionYear: "2020",
            subEquipments: "5 Equipments",
            location: "Ditzingen",
            serviceAgreement: "",
        },
    ],
};

const writeToFile = (
    page: number,
    object: MymachineResponse,
    modifierName: string = ""
) => {
    fs.writeFileSync(
        `${output}mymachine${modifierName}-page${page}.json`,
        JSON.stringify(object)
    );
};

writeToFile(1, response);
writeToFile(2, {
    ...response,
    items: [...response.items!].reverse(),
    nextPage: getPageLink(3),
});
writeToFile(3, {
    ...response,
    nextPage: getPageLink(4),
});
writeToFile(4, {
    ...response,
    items: [...response.items!].reverse(),
    nextPage: "",
});

const withoutService = "-without-service-agreement";
writeToFile(
    1,
    {
        ...response,
        items: response.items!.map((item) => ({
            ...item,
            serviceAgreement: undefined,
        })),
        nextPage: getPageLink(2, withoutService),
    },
    withoutService
);
writeToFile(
    2,
    {
        ...response,
        items: response
            .items!.map((item) => ({
                ...item,
                number: item.number + "1",
                serviceAgreement: undefined,
            }))
            .reverse(),
        nextPage: "",
    },
    withoutService
);

const serviceCaseCreateDisabled = "-with-disabled-service-case-creation";

var serviceCaseCreateDisabledResponse = { ...response };
serviceCaseCreateDisabledResponse.isCreateCaseAllowed = false;

writeToFile(
    1,
    {
        ...serviceCaseCreateDisabledResponse,
        items: serviceCaseCreateDisabledResponse
            .items!.map((item) => ({
                ...item,
                serviceAgreement: undefined,
            }))
            .reverse(),
        nextPage: "",
    },
    serviceCaseCreateDisabled
);
